import { render, staticRenderFns } from "./SnowExportButton.vue?vue&type=template&id=e63973b6&scoped=true&"
import script from "./SnowExportButton.vue?vue&type=script&lang=js&"
export * from "./SnowExportButton.vue?vue&type=script&lang=js&"
import style0 from "./SnowExportButton.vue?vue&type=style&index=0&id=e63973b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63973b6",
  null
  
)

export default component.exports